var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2216_4616",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.75C5.446 1.75 1.75 5.446 1.75 10C1.75 14.1167 4.7695 17.5322 8.713 18.151V12.3842H6.6175V10H8.713V8.185C8.713 6.11425 9.94225 4.97575 11.8315 4.97575C12.7307 4.97575 13.6795 5.14075 13.6795 5.14075V7.17025H12.64C11.617 7.17025 11.2952 7.8055 11.2952 8.45725V10.0082H13.5805L13.2175 12.3925H11.2952V18.1592C15.2387 17.5405 18.25 14.1167 18.25 10C18.25 5.446 14.5622 1.75825 10.0082 1.75825L10 1.75Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2216_4616)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f5d708800fedbbaf403028ce8b823325.svg";
export { ForwardRef as ReactComponent };